import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from './services/api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Protocolos from './pages/Protocolos';
import NovoProtocolo from './pages/NovoProtocolo';
import DetalheProtocolo from './pages/DetalheProtocolo';
import FormularioDinamico from './pages/FormularioDinamico';
import AnaliseTecnica from './pages/AnaliseTecnica';
import TecnicoAnalises from './pages/TecnicoAnalises';
import TecnicoVistorias from './pages/TecnicoVistorias';
import AdminSisobra from './pages/AdminSisobra';
import AdminUsuarios from './pages/AdminUsuarios';
import { routes, routePatterns } from './lib/routes';

function App() {
  const hasToken = Boolean(localStorage.getItem('token'));
  const { data: user, isLoading, isError } = useQuery(
    'me',
    () => api.get('/usuarios/me').then((r) => r.data),
    { retry: false, enabled: hasToken }
  );

  if (hasToken && !user && isLoading) {
    return (
      <div className="sispro-app-loading">
        <div className="sispro-app-loading-inner">
          <span className="sispro-app-loading-badge">SP</span>
          <p>Carregando sessao...</p>
        </div>
      </div>
    );
  }

  if (hasToken && isError && !user) {
    return <Navigate to={routes.login} replace />;
  }

  const authed = hasToken && Boolean(user);
  const toLogin = <Navigate to={routes.login} replace />;
  const toDashboard = <Navigate to={routes.dashboard} replace />;

  return (
    <Routes>
      <Route path={routes.login} element={!authed ? <Login /> : toDashboard} />
      <Route path={routes.home} element={authed ? toDashboard : toLogin} />
      <Route path={routes.dashboard} element={authed ? <Dashboard /> : toLogin} />
      <Route path={routes.protocolos} element={authed ? <Protocolos /> : toLogin} />
      <Route path={routes.novoProtocolo} element={authed ? <NovoProtocolo /> : toLogin} />
      <Route path={routePatterns.protocolo} element={authed ? <DetalheProtocolo /> : toLogin} />
      <Route path={routePatterns.formulario} element={authed ? <FormularioDinamico /> : toLogin} />
      <Route path={routePatterns.analise} element={authed ? <AnaliseTecnica /> : toLogin} />
      <Route path={routes.tecnicoAnalises} element={authed ? <TecnicoAnalises /> : toLogin} />
      <Route path={routes.tecnicoVistorias} element={authed ? <TecnicoVistorias /> : toLogin} />
      <Route path={routes.adminSisobra} element={authed ? <AdminSisobra /> : toLogin} />
      <Route path={routes.adminUsuarios} element={authed ? <AdminUsuarios /> : toLogin} />
    </Routes>
  );
}

export default App;
